import ImoveisIndex from '../imoveis/pages/ImoveisIndex.vue';
import { laisPath } from '../laisRouteHelpers';

const entryInformationResultListRoute = {
  path: laisPath('informacoes-de-entrada/:houseId'),
  name: 'entry-information-result-list',
  component: ImoveisIndex,
  meta: {
    referenceAuthenticated: true,
  },
};

export default entryInformationResultListRoute;
